/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolImagesearchRollerIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-imagesearch-roller"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M15.85 23.8L10.88 23.8Q10.4 23.8 10.06 23.46Q9.72 23.13 9.72 22.65L9.72 16.05Q9.72 15.57 10.06 15.24Q10.4 14.9 10.88 14.9L12.03 14.9L12.03 12.7Q12.03 12.7 12.03 12.7Q12.03 12.7 12.03 12.7L3.83 12.7Q2.7 12.7 1.95 11.94Q1.2 11.18 1.2 10.07L1.2 6.15Q1.2 5.05 1.95 4.29Q2.7 3.52 3.83 3.52L5.92 3.52L5.92 2.33Q5.92 1.85 6.25 1.52Q6.58 1.2 7.05 1.2L19.68 1.2Q20.13 1.2 20.46 1.52Q20.8 1.85 20.8 2.33L20.8 7.35Q20.8 7.83 20.46 8.16Q20.13 8.5 19.68 8.5L7.05 8.5Q6.58 8.5 6.25 8.16Q5.92 7.83 5.92 7.33L5.92 6.17L3.85 6.17Q3.85 6.17 3.85 6.17Q3.85 6.17 3.85 6.17L3.85 10.05Q3.85 10.05 3.85 10.05Q3.85 10.05 3.85 10.05L12.05 10.05Q13.15 10.05 13.91 10.81Q14.68 11.57 14.68 12.68L14.68 14.9L15.85 14.9Q16.32 14.9 16.65 15.24Q16.98 15.57 16.98 16.05L16.98 22.65Q16.98 23.13 16.65 23.46Q16.32 23.8 15.85 23.8Z" fill={color} />
    </svg>
  );
}
